import React, { Component } from 'react';

class When extends Component {
  render() {
    return (
      <div className="App">
      <div className="textWhen">
        <h1>Orari di apertura<br /></h1>
        <br />

        <h1>LUNEDÌ <br /></h1>
        <h2>CHIUSO</h2>
        <br /> <br />
        <h1>MARTEDÌ → VENERDÌ <br /></h1>
        <h2>15:00 - 19:00</h2>
        <br /> <br />
        <h1>SABATO <br /></h1>
        <h2>10:00 - 19:00</h2>
        <br /> <br />
        <h1>DOMENICA <br /></h1>
        <h2>15:00 - 19:00</h2>
      </div>
      </div>
    )
  }
}


export default When;
